module.exports = __webpack_public_path__ + "img/year.fb697d24.png";